/**
 * "Open the map at this station", asked from somewhere that is not the map.
 *
 * The same shape as `src/board-request.js`, for the same reason: this app's
 * router runs a memory history with no URLs to carry a station in, so the
 * request is left here and the map picks it up.
 *
 * ONE CALLER TODAY — `share-open.js`, landing a shared map link — and the
 * pattern at the top of board-request.js is what the map consumes it with:
 * watched reactively as well as taken at mount and at view-enter, because a
 * link can arrive before the page exists, while it is mounting, or an hour
 * after it is already on screen showing something else.
 */
import { computed, ref } from 'vue';

const pending = ref(null);

/** Ask the map to select this station when it next opens. Null for a bad id. */
export function requestMapStation(station) {
  const stopId = Number(station?.stopId);
  if (!Number.isFinite(stopId) || stopId <= 0) return null;
  pending.value = { stopId, name: String(station.name ?? '') };
  return pending.value;
}

/** The request as something the map can watch, without consuming it. */
export const requestedMapStation = computed(() => pending.value);

/** The request, cleared. Null when nobody asked. */
export function takeRequestedMapStation() {
  const asked = pending.value;
  pending.value = null;
  return asked;
}

/** Tests only. */
export function clearRequestedMapStation() {
  pending.value = null;
}
